document.addEventListener("DOMContentLoaded", function() {
  const header = document.querySelector('.header-wrapper');
  const hero = document.querySelector('#image-with-text'); // Replace this class name with Hero Section Identifier.
  const utility = document.querySelector('.utility-bar');

  function adjustHeroPosition() {
    if (header && hero) {
      const headerHeight = header.offsetHeight; // Get the height of the header
      const utilityHeight = utility ? utility.offsetHeight : 0; // Get the height of the utility bar, if it exists
      hero.style.top = `-${headerHeight}px`; // Set the top of the banner to the height of the header
      hero.style.marginBottom = `-${headerHeight}px`; // Set the margin-bottom of the banner to the height of the header
      hero.style.visibility = 'visible'; // Make the banner visible again
      hero.style.minHeight = 'unset';
      hero.style.maxHeight = '100svh';
      hero.style.position = 'relative';
      hero.style.height = `calc(100svh - ${utilityHeight}px)`;
    }
  }

  adjustHeroPosition(); // Call the function on page load

  window.addEventListener('resize', function() {
    hero.style.visibility = 'hidden'; // Hide the hero on resize to prevent jump
    adjustHeroPosition();
  }); // Re-adjust when the window is resized
});
